(function () {
  'use strict';

  function iconPlus() {
    return (
      '<svg class="off faq-icon" width="24" height="24" viewBox="0 0 24 24" fill="none" aria-hidden="true">' +
      '<line x1="12" y1="2" x2="12" y2="22" stroke-width="2"/>' +
      '<line x1="2" y1="12" x2="22" y2="12" stroke-width="2"/></svg>'
    );
  }

  function iconMinus() {
    return (
      '<svg class="on closed faq-icon" width="24" height="24" viewBox="0 0 24 24" fill="none" aria-hidden="true">' +
      '<line x1="2" y1="12" x2="22" y2="12" stroke-width="2"/></svg>'
    );
  }

  function buildRow(question, answerHtml, index) {
    var bodyId = 'faq-body-' + index;

    var row = document.createElement('div');
    row.className = 'faq-accordion-row';

    var button = document.createElement('button');
    button.type = 'button';
    button.className = 'faq-row-toggle';
    button.setAttribute('aria-controls', bodyId);
    button.setAttribute('aria-expanded', 'false');
    button.innerHTML = '<span class="faq-question"></span>' + iconPlus() + iconMinus();
    button.querySelector('.faq-question').textContent = question;

    var body = document.createElement('div');
    body.id = bodyId;
    body.className = 'faq-body closed';
    body.innerHTML =
      '<div tabindex="-1" class="faq-body-inner"><div class="rich-text">' + answerHtml + '</div></div>';

    var plus = button.querySelector('.off');
    var minus = button.querySelector('.on');

    button.addEventListener('click', function () {
      var open = button.getAttribute('aria-expanded') !== 'true';
      button.setAttribute('aria-expanded', String(open));
      body.classList.toggle('closed', !open);
      plus.classList.toggle('closed', open);
      minus.classList.toggle('closed', !open);
    });

    row.appendChild(button);
    row.appendChild(body);
    return row;
  }

  function enhance(root) {
    var source = root.querySelector('[data-faq-source]');
    var list = root.querySelector('[data-faq-list]');
    if (!source || !list) return;

    var items = source.querySelectorAll('li');
    if (!items.length) {
      root.hidden = true;
      return;
    }

    items.forEach(function (item, index) {
      var heading = item.querySelector('h2, h3, h4, h5, h6');
      var question = heading ? heading.textContent.trim() : (item.getAttribute('title') || '').trim();

      var answer = item.cloneNode(true);
      var answerHeading = answer.querySelector('h2, h3, h4, h5, h6');
      if (answerHeading) answerHeading.remove();

      list.appendChild(buildRow(question, answer.innerHTML.trim(), index));
    });

    source.remove();
  }

  function init() {
    document.querySelectorAll('[data-faq]').forEach(enhance);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
